<template>
  <Modal
    :value="visible"
    :mask-closable="false"
    :footer-hide="true"
    width="980"
    class-name="select-product-modal"
    @on-visible-change="onVisibleChange"
  >
    <div class="modal-header">
      <span class="modal-title">选择管理商品</span>
    </div>

    <div class="modal-body">
      <!-- 搜索筛选栏 -->
      <div class="filter-bar">
        <div class="filter-item">
          <span class="label">品类</span>
          <Select v-model="form_data.product_category_id" placeholder="全部品类" style="width: 140px" @on-change="onSearch">
            <Option :value="0">全部品类</Option>
            <Option v-for="cate in cate_list" :key="cate.product_category_id" :value="cate.product_category_id">{{ cate.category_name_cn }}</Option>
          </Select>
        </div>
        <div class="search-box">
          <img class="search-icon-btn" src="@/assets/images/icon-search-workbench.png" alt="" />
          <input v-model="form_data.keyword" type="text" placeholder="商品名称关键词" @keyup.enter="onSearch" />
          <div class="search-btn" @click="onSearch">搜索</div>
        </div>
      </div>

      <!-- 商品表格 -->
      <div class="table-box">
        <table>
          <colgroup>
            <col style="width: 50px;" />
            <col />
            <col style="width: 120px;" />
            <col style="width: 140px;" />
            <col style="width: 80px;" />
            <col style="width: 110px;" />
          </colgroup>
          <thead>
            <tr>
              <th style="width: 50px;">
                <div class="col-check">
                  <Checkbox :indeterminate="indeterminate" :value="checkAll" @on-change="handleCheckAll"></Checkbox>
                </div>
              </th>
              <th>商品信息</th>
              <th style="width: 120px;">款式类型</th>
              <th style="width: 140px;">款号</th>
              <th style="width: 80px;">库存</th>
              <th style="width: 110px;">在售价(元)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in product_list" :key="item.id">
              <td style="width: 50px;">
                <div class="col-check">
                  <Checkbox
                    :value="checked_list.includes(item.uuid)"
                    @on-change="(val) => handleSingleCheck(val, item)"
                  ></Checkbox>
                </div>
              </td>
              <td>
                <div class="col-product-info">
                  <img class="product-image" :src="item.image | default_img" alt="" />
                  <div class="product-info">
                    <span v-if="item.sale_mode === 1" class="new-tag">预售</span>
                    <span class="product-name">{{ item.name }}</span>
                  </div>
                </div>
              </td>
              <td style="width: 120px;">{{ item.product_category_name }}</td>
              <td style="width: 140px;">{{ (item.param || []).find(i=>{return i.key === '款号'}).value || '-' }}</td>
              <td style="width: 80px;">{{ item.stock }}</td>
              <td style="width: 110px;">¥{{ item.sale_price }}</td>
            </tr>
            <tr v-if="!product_list.length">
              <td colspan="6">
                <div class="empty-box">暂无数据</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer">
      <span class="select-desc">已选 <span class="count">{{ checked_list.length }}</span>件，点击「确定添加」绑定券包</span>
      <div class="footer-btns">
        <div class="btn cancel" @click="onCancel">取消</div>
        <div class="btn confirm" :class="{ disabled: !checked_list.length }" @click="onConfirm">确定添加</div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { ProductList, ProductCategoryList } from "@/api/index";
import { mapState } from "vuex";
export default {
  name: "SelectProductModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  data() {
    return {
      form_data: {
        page: 1,
        limit: 10,
        product_category_id: 0,
        keyword: "",
        status: 'onsale',
      },
      cate_list: [], // 品类列表
      product_list: [],
      checked_list: [], // 已选商品 uuid
      checked_items: [], // 已选商品完整数据（confirm 时回传）
      indeterminate: false,
      checkAll: false,
    };
  },
  methods: {
    onVisibleChange(val) {
      if (val) {
        this.init();
      } else {
        this.onCancel();
      }
    },
    init() {
      this.form_data.page = 1;
      this.form_data.product_category_id = 0;
      this.form_data.keyword = "";
      this.checked_list = [];
      this.checked_items = [];
      this.getCateList();
      this.getProductList();
    },
    // 获取店铺商品品类列表
    getCateList() {
      ProductCategoryList().then((response) => {
        const { data } = response;
        this.cate_list = data;
      });
    },
    async getProductList() {
      ProductList({
        ...this.form_data,
        code: this.userInfo.code,
        // status: this.status,
      }).then((response) => {
        const { data } = response;
        this.product_list = (data || []).map((item) => ({
          ...item,
          stock: (item.product_spec || []).reduce((acc, cur) => acc + cur.stock, 0),
        }));
      });
    },
    onSearch() {
      this.form_data.page = 1;
      this.getProductList();
    },
    handleSingleCheck(checked, item) {
      if (checked) {
        if (!this.checked_list.includes(item.uuid)) {
          this.checked_list.push(item.uuid);
          this.checked_items.push(item);
        }
      } else {
        const index = this.checked_list.indexOf(item.uuid);
        if (index > -1) {
          this.checked_list.splice(index, 1);
          this.checked_items.splice(index, 1);
        }
      }
      this.onCheckChange();
    },
    onCheckChange() {
      if (this.checked_list.length === 0) {
        this.indeterminate = false;
        this.checkAll = false;
      } else if (this.checked_list.length === this.product_list.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else {
        this.indeterminate = true;
        this.checkAll = false;
      }
    },
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.product_list.forEach((item) => {
          if (!this.checked_list.includes(item.uuid)) {
            this.checked_list.push(item.uuid);
            this.checked_items.push(item);
          }
        });
      } else {
        const pageIds = this.product_list.map((item) => item.uuid);
        this.checked_list = this.checked_list.filter((uuid) => !pageIds.includes(uuid));
        this.checked_items = this.checked_items.filter((item) => !pageIds.includes(item.uuid));
      }
    },
    onCancel() {
      this.$emit("update:visible", false);
    },
    onConfirm() {
      if (!this.checked_list.length) return;
      this.$emit("confirm", this.checked_items);
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .select-product-modal {
  text-align: left;
  line-height: 1.5;
  .ivu-modal-content {
    border-radius: 10px;
  }

  .ivu-modal-body {
    padding: 0;
  }

  .ivu-modal-close {
    top: 14px;
    right: 14px;
  }
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 24px 20px 10px 20px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;

  .modal-title {
    font-size: 18px;
    font-weight: bold;
    color: #0F1115;
  }
}

.modal-body {
  padding: 16px 20px 0;
  text-align: left;
  min-height: 500px;

  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .filter-item {
      display: flex;
      align-items: center;
      gap: 8px;

      .label {
        font-size: 14px;
        color: #333333;
      }
    }

    .search-box {
      display: flex;
      align-items: center;

      width: 420px;
      height: 40px;
      background: #F8F9FB;
      border-radius: 30px 30px 30px 30px;
      border: 1px solid #EBEBEB;

      .search-icon-btn {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        margin-right: 8px;
        margin-left: 16px;
      }
      input {
        flex: 1;
        border: none;
        outline: none;
        background: transparent;
        font-size: 14px;
        color: #333333;
      }

      .search-btn {
        margin-right: 6px;
        flex-shrink: 0;
        height: 32px;
        padding: 6px 32px;
        background: #ff5967;
        border-radius: 20px;
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
        color: #ffffff;
        cursor: pointer;

        &:hover {
          opacity: 0.9;
        }
      }
    }
  }

  .table-box {
    margin-top: 16px;
    max-height: 420px;
    overflow: auto;

    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      border-spacing: 0;
      font-size: 14px;

      thead {
        background: #f6f7fa;
        height: 40px;
        position: sticky;
        top: 0;
        z-index: 2;

        tr {
          border: 1px solid #e3e3e3;
          th {
            vertical-align: middle;
            padding: 10px;
            overflow: hidden;
            text-align: center;
            color: #666666;
            font-weight: 400;
          }
        }
      }

      tbody {
        tr {
          border: 1px solid #e3e3e3;

          td {
            vertical-align: middle;
            padding: 10px;
            overflow: hidden;
            color: #333333;
            font-weight: 400;
            text-align: center;

            .col-check {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 50px;
              padding: 12px;

              ::v-deep .ivu-checkbox-group-item,
              .ivu-checkbox-wrapper-checked {
                border-spacing: 0;

                span {
                  &:nth-child(2) {
                    display: none;
                  }
                }
              }
            }

            .col-product-info {
              display: flex;
              align-items: center;
              gap: 16px;
              width: 100%;
              text-align: left;

              .product-image {
                width: 64px;
                height: 64px;
                flex-shrink: 0;
                border: 1px solid #e3e3e3;
                border-radius: 8px;
                object-fit: cover;
                flex-shrink: 0;
              }

              .product-info {
                flex: 1;
                min-width: 0;

                font-size: 14px;
                color: #333333;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                word-break: break-all;

                .new-tag {
                  padding: 1px 4px;
                  background: #ff5967;
                  border-radius: 4px;
                  font-size: 12px;
                  color: #ffffff;
                  display: inline-block;
                  margin-right: 4px;
                }
              }
            }

            .empty-box {
              text-align: center;
              padding: 40px 0;
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px 20px;
  border-top: 1px solid #f0f0f0;

  .select-desc {
    font-size: 14px;
    color: #999999;
    .count {
      color: #FF5967;
    }
  }

  .footer-btns {
    display: flex;
    gap: 10px;

    .btn {
    width: 100px;
      height: 40px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      cursor: pointer;

      &.cancel {
        background: #ffffff;
        border: 1px solid #e3e3e3;
        color: #666666;
        font-weight: bold;

        &:hover {
          border-color: #cccccc;
        }
      }

      &.confirm {
        width: 120px;
        background: #ff5967;
        color: #ffffff;
        font-weight: bold;

        &:hover {
          opacity: 0.9;
        }

        &.disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
